import React, { useState, useMemo, useRef, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import {
  TableContainer,
  Paper,
  Box,
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  TextField,
  Tooltip,
  Grid,
  Button,
  Autocomplete,
  Stack,
} from "@mui/material";
import dayjs from "dayjs";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  StyledAgGridContainer,
  inputStyle,
  ModernHeader,
} from "components/StyledComponents/styledComponents.js";
import { useNavigate } from "react-router-dom";
import useBusinessMonthYear from "components/GlobalHooks/useMonthlyBusiness";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { monthEndStyles } from "components/Styles/monthEndStyles";
import { CustomPaper } from "components/Styles/globalStyles";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import { IconButton, Modal } from "@mui/material";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import { useMaterialUIController } from "context";
import TotalExpenditureStatement from "./expenses";
import { Eye } from "lucide-react";
import GstTdsGrid from "./gstComponent";
import FinancialSummary from "./newP&LSummary";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import GstDialogPopup from "./gstDialogPopup";

export default function ActualProfitAndLoss() {
  const [expenseIsOpen, setExpenseIsOpen] = useState(false);
  const { monthIdData, setAlert, handleClose } = useBusinessMonthYear();
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [monthId, setMonthId] = useState(0);
  const [dsaId, setDsaId] = useState(0);
  const businessCodeRef = useRef(0);
  const [misFilters, setMisFilters] = useState([{ column: null, text: "" }]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [servicesData, setServicesData] = useState([]);
  const MInput = inputStyle();
  const currentMonthStart = dayjs().startOf("month").format("YYYY-MM-DD");
  const currentMonthEnd = dayjs().endOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(dayjs().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [rowData, setRowData] = useState([]);
  const [dsaBusiness, setDsaBusiness] = useState([]);
  const [footerData, setFooterData] = useState([]);
  const [dsaFooterData, setDsaFooterData] = useState([]);
  const getToken = () => Cookie.get("jwt_token");
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [selectedDSA, setSelectedDSA] = useState(null);
  const [childGridData, setChildGridData] = useState([]);
  const [receivableFooterData, setReceivableFooterData] = useState([]);
  const [dsaReceivables, setDsaReceivables] = useState([]);
  const [footerChildGridData, setFooterChildGridData] = useState([]);
  const [recievablesAgainstInvoiceFooterData, setRecievablesAgainstInvoiceFooterData] = useState(
    []
  );
  const [companyId, setCompanyId] = useState(false);
  const [recievablesAgainstInvoiceData, setRecievablesAgainstInvoiceData] = useState([]);
  const [recievablesAgtInvData, setRecievablesAgtInvData] = useState([]);
  const [recievablesAgtInvfooterData, setRecievablesAgtInvfooterData] = useState([]);
  const [notRecievablesNanvoiceData, setNotRecievablesNanvoiceData] = useState([]);
  const [recievablesNotInvData, setRecievablesNotInvData] = useState([]);
  const [recievablesNotInvfooterData, setRecievablesNotInvfooterData] = useState([]);
  const [notRecievablesAgainstInvoiceFooterData, setNotRecievablesAgainstInvoiceFooterData] =
    useState([]);
  const [selectedRange, setSelectedRange] = useState("30");
  const [selectedDSAName, setSelectedDSAName] = useState(user?.dsaName || "");
  const [highlightAllRows, setHighlightAllRows] = useState(false);
  const [highlightAllRowsInv, setHighlightAllRowsInv] = useState(false);
  const [gstData, setGstData] = useState([]);
  const [gstStartDate, setGstStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [gstEndDate, setGstEndDate] = useState(dayjs().endOf("month").format("YYYY-MM-DD"));
  const [payStartDate, setPayStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [payEndDate, setPayEndDate] = useState(dayjs().endOf("month").format("YYYY-MM-DD"));

  const [gstLiabilityData, setGstLiabilityData] = useState([]);
  const [gstLiabilityOpen, setGstLiabilityOpen] = useState(false);
  const [gstLiabilityLoading, setGstLiabilityLoading] = useState(false);
  const [igstLiabilityData, setIgstLiabilityData] = useState([]);
  const [igstLiabilityOpen, setIgstLiabilityOpen] = useState(false);
  const [igstLiabilityLoading, setIgstLiabilityLoading] = useState(false);
  const [gstPaidData, setGstPaidData] = useState([]);
  const [gstPaidOpen, setGstPaidOpen] = useState(false);
  const [gstPaidLoading, setGstPaidLoading] = useState(false);
  const [igstPaidData, setIgstPaidData] = useState([]);
  const [igstPaidOpen, setIgstPaidOpen] = useState(false);
  const [igstPaidLoading, setIgstPaidLoading] = useState(false);
  const [gstReceivableData, setGstReceivableData] = useState([]);
  const [gstReceivableOpen, setGstReceivableOpen] = useState(false);
  const [gstReceivableLoading, setGstReceivableLoading] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // Callback passed down through FinancialSummary → BalanceSheet
  // When "Duties and Taxes" is clicked in the Balance Sheet, it calls this with
  // tabIndex = 4, which switches the top-level tab to "GST Reports".
  // ─────────────────────────────────────────────────────────────────────────────
  const handleNavigateToTab = useCallback((tabIndex) => {
    setActiveTab(tabIndex);
  }, []);

  const ExpenditureCellRenderer = (params) => {
    const handleEyeClick = () => {
      params.onEyeClick(params.data.dsaId);
    };
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
        <span style={{ marginRight: "8px" }}>{`₹ ${params.value?.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
        })}`}</span>
        <button
          onClick={handleEyeClick}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "0",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Eye size={22} color="#007bff" />
        </button>
      </div>
    );
  };

  const DaysFilterButtons = ({ onFilter, onDownload }) => {
    const ranges = [
      { label: "30 Days", days: 30 },
      { label: "60 Days", days: 60 },
      { label: "90 Days", days: 90 },
      { label: "Above 90", days: 91, above: true },
      { label: `ALL - ${selectedDSAName}`, days: 0, allByCom: true },
      { label: "All NoN Inv", days: -1, all: true },
    ];
    const handleClick = (label, days, isAbove, all, allByCom) => {
      setSelectedRange(days);
      setHighlightAllRows(all === true);
      const today = dayjs();
      let startDate = null;
      let endDate = null;
      if (all) {
        startDate = null;
        endDate = null;
      } else if (isAbove) {
        endDate = today.subtract(90, "day").format("YYYY-MM-DD");
      } else if (days === 30) {
        startDate = today.subtract(30, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
      } else if (days === 60) {
        startDate = today.subtract(60, "day").format("YYYY-MM-DD");
        endDate = today.subtract(31, "day").format("YYYY-MM-DD");
      } else if (days === 90) {
        startDate = today.subtract(90, "day").format("YYYY-MM-DD");
        endDate = today.subtract(61, "day").format("YYYY-MM-DD");
      }
      onFilter({ startDate, endDate, isAbove, all, allByCom });
    };
    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 1 }}>
        {ranges.map(({ label, days, above, all, allByCom }) => {
          const isSelected = selectedRange === days;
          return (
            <Button
              key={label}
              variant={isSelected ? "contained" : "outlined"}
              onClick={() => handleClick(label, days, above, all, allByCom)}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 700,
                px: 2,
                py: 0.5,
                borderColor: "#FFA726",
                color: isSelected ? "#fff" : "#2E2E2E",
                backgroundColor: isSelected ? "#D46B08" : "#FFF3E0",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: isSelected ? "#FB8C00" : "#FFB74D",
                  borderColor: "#FB8C00",
                  boxShadow: isSelected
                    ? "0 0 12px rgba(255,152,0,0.6)"
                    : "0 0 6px rgba(255,152,0,0.3)",
                },
              }}
            >
              {label}
            </Button>
          );
        })}
        <Button
          variant="contained"
          color="success"
          startIcon={<DownloadIcon />}
          onClick={onDownload}
          sx={{
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 700,
            px: 3,
            py: 0.8,
            backgroundColor: "#2E7D32",
            color: "#ffffff",
            "&:hover": { backgroundColor: "#1B5E20" },
          }}
        >
          Download Excel
        </Button>
      </Box>
    );
  };
  DaysFilterButtons.propTypes = {
    onFilter: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
  };

  const handleOpenModal = () => setExpenseIsOpen(true);
  const handleCloseModal = () => setExpenseIsOpen(false);
  const handleChange = (event, newValue) => setActiveTab(newValue);

  const tabs = [
    { label: "MIS Report" },
    { label: "DSA'S P & L Report" },
    { label: "Estimated P & L" },
    { label: "Actual P & L" },
    { label: "GST Reports" },
  ];

  const fetchEntriesByMonthId = async () => {
    if (startDate && endDate) {
      const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
      setLoading(true);
      try {
        const options = {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        };
        const responseA = await fetch(
          `${URLs.mis}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
          options
        );
        const dataA = await responseA.json();
        if (responseA.ok) {
          setServicesData([...dataA]);
        } else {
          throw new Error("Failed to fetch entries data");
        }
      } catch (error) {
        showAlert(`Failed to fetch data: ${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    } else {
      showAlert("Please select both start and end dates", "error");
    }
  };

  const fetchGstSummary = async () => {
    const token = getToken();
    if (!token) {
      showAlert("Session expired. Please log in again.", "error");
      return;
    }

    const formattedStart = dayjs(gstStartDate).format("YYYY-MM-DD");
    const formattedEnd = dayjs(gstEndDate).format("YYYY-MM-DD");
    const formattedPayStart = dayjs(payStartDate).format("YYYY-MM-DD");
    const formattedPayEnd = dayjs(payEndDate).format("YYYY-MM-DD");

    const url = `${URLs.gstSummary}?startDate=${formattedStart}&endDate=${formattedEnd}&payStartDate=${formattedPayStart}&payEndDate=${formattedPayEnd}`;

    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok) {
        setGstData(data);
      } else {
        throw new Error("Failed to fetch GST summary");
      }
    } catch (error) {
      showAlert(`Failed to fetch GST data: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchGstLiability = async () => {
    const token = getToken();
    if (!token) {
      showAlert("Session expired. Please log in again.", "error");
      return;
    }
    const s = dayjs(gstStartDate).format("YYYY-MM-DD");
    const e = dayjs(gstEndDate).format("YYYY-MM-DD");
    setGstLiabilityLoading(true);
    setGstLiabilityOpen(true);
    setGstLiabilityData([]);
    try {
      const response = await fetch(`${URLs.gstliability}?startDate=${s}&endDate=${e}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      if (response.status === 401)
        throw new Error("Unauthorized (401) — your session may have expired.");
      if (!response.ok) throw new Error(`Failed to fetch GST liability (${response.status})`);
      setGstLiabilityData(await response.json());
    } catch (error) {
      showAlert(`Failed to fetch GST liability: ${error.message}`, "error");
      setGstLiabilityOpen(false);
    } finally {
      setGstLiabilityLoading(false);
    }
  };

  const fetchIgstLiability = async () => {
    const token = getToken();
    if (!token) {
      showAlert("Session expired. Please log in again.", "error");
      return;
    }
    const s = dayjs(gstStartDate).format("YYYY-MM-DD");
    const e = dayjs(gstEndDate).format("YYYY-MM-DD");
    setIgstLiabilityLoading(true);
    setIgstLiabilityOpen(true);
    setIgstLiabilityData([]);
    try {
      const response = await fetch(`${URLs.igstliability}?startDate=${s}&endDate=${e}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      if (response.status === 401)
        throw new Error("Unauthorized (401) — your session may have expired.");
      if (!response.ok) throw new Error(`Failed to fetch IGST liability (${response.status})`);
      setIgstLiabilityData(await response.json());
    } catch (error) {
      showAlert(`Failed to fetch IGST liability: ${error.message}`, "error");
      setIgstLiabilityOpen(false);
    } finally {
      setIgstLiabilityLoading(false);
    }
  };

  const fetchGstPaid = async () => {
    const token = getToken();
    if (!token) {
      showAlert("Session expired. Please log in again.", "error");
      return;
    }
    const s = dayjs(payStartDate).format("YYYY-MM-DD");
    const e = dayjs(payEndDate).format("YYYY-MM-DD");
    setGstPaidLoading(true);
    setGstPaidOpen(true);
    setGstPaidData([]);
    try {
      const response = await fetch(`${URLs.gstpaid}?payStartDate=${s}&payEndDate=${e}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      if (response.status === 401)
        throw new Error("Unauthorized (401) — your session may have expired.");
      if (!response.ok) throw new Error(`Failed to fetch GST paid data (${response.status})`);
      setGstPaidData(await response.json());
    } catch (error) {
      showAlert(`Failed to fetch GST paid: ${error.message}`, "error");
      setGstPaidOpen(false);
    } finally {
      setGstPaidLoading(false);
    }
  };

  const fetchIgstPaid = async () => {
    const token = getToken();
    if (!token) {
      showAlert("Session expired. Please log in again.", "error");
      return;
    }
    const s = dayjs(payStartDate).format("YYYY-MM-DD");
    const e = dayjs(payEndDate).format("YYYY-MM-DD");
    setIgstPaidLoading(true);
    setIgstPaidOpen(true);
    setIgstPaidData([]);
    try {
      const response = await fetch(`${URLs.igstpaid}?payStartDate=${s}&payEndDate=${e}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      if (response.status === 401)
        throw new Error("Unauthorized (401) — your session may have expired.");
      if (!response.ok) throw new Error(`Failed to fetch IGST paid data (${response.status})`);
      setIgstPaidData(await response.json());
    } catch (error) {
      showAlert(`Failed to fetch IGST paid: ${error.message}`, "error");
      setIgstPaidOpen(false);
    } finally {
      setIgstPaidLoading(false);
    }
  };

  const fetchGstReceivable = async () => {
    const token = getToken();
    if (!token) {
      showAlert("Session expired. Please log in again.", "error");
      return;
    }
    const s = dayjs(gstStartDate).format("YYYY-MM-DD");
    const e = dayjs(gstEndDate).format("YYYY-MM-DD");
    setGstReceivableLoading(true);
    setGstReceivableOpen(true);
    setGstReceivableData([]);
    try {
      const response = await fetch(`${URLs.gstreceivable}?startDate=${s}&endDate=${e}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      if (response.status === 401)
        throw new Error("Unauthorized (401) — your session may have expired.");
      if (!response.ok) throw new Error(`Failed to fetch GST receivable data (${response.status})`);
      setGstReceivableData(await response.json());
    } catch (error) {
      showAlert(`Failed to fetch GST receivable: ${error.message}`, "error");
      setGstReceivableOpen(false);
    } finally {
      setGstReceivableLoading(false);
    }
  };

  const handleParticularClick = (particularsText) => {
    const text = particularsText?.toLowerCase() || "";
    if (text.includes("total igst liability") || text.includes("igst liability"))
      return fetchIgstLiability();
    if (text.includes("total igst paid") || text.includes("igst paid")) return fetchIgstPaid();
    if (text.includes("total gst liability") || text.includes("gst liability"))
      return fetchGstLiability();
    if (text.includes("total gst paid") || text.includes("gst paid")) return fetchGstPaid();
    if (text.includes("total gst recei") || text.includes("gst receivable"))
      return fetchGstReceivable();
  };

  const fetchEntriesByDSAMonthId = async () => {
    if (startDate && endDate) {
      const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
      setLoading(true);
      try {
        const options = {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        };
        const responseA = await fetch(
          `${URLs.dsaFinancialDetailss}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
          options
        );
        const dataA = await responseA.json();
        if (responseA.ok) {
          setDsaBusiness([...dataA]);
        } else {
          throw new Error("Failed to fetch entries data");
        }
      } catch (error) {
        showAlert(`Failed to fetch data: ${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    } else {
      showAlert("Please select both start and end dates", "error");
    }
  };

  const showAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleCloseAlert = () => setOpen(false);

  useEffect(() => {
    const activeMisFilters = misFilters.filter((f) => f.column && f.text.trim() !== "");
    if (activeMisFilters.length === 0) {
      setFilteredData(servicesData);
      return;
    }
    const filtered = servicesData.filter((row) =>
      activeMisFilters.every(({ column, text }) => {
        const val = row[column.field];
        if (val == null) return false;
        if (typeof val === "number") return val.toString().includes(text);
        return val.toString().toLowerCase().includes(text.toLowerCase());
      })
    );
    setFilteredData(filtered);
  }, [misFilters, servicesData]);

  useEffect(() => {
    if (monthIdData && monthIdData.length > 0) {
      setMonthId(monthIdData[0].businessMonthID);
      fetchEntriesByMonthId();
    }
  }, [monthIdData]);

  const handlePrintInvoice = useCallback(async (invoiceNo) => {
    try {
      if (!invoiceNo) throw new Error("Invoice number is missing");
      const response = await fetch(`${URLs.headOfficeInvoiceView}/${invoiceNo}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (!response.ok) throw new Error("Failed to fetch invoice");
      window.open(URL.createObjectURL(await response.blob()), "_blank");
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  }, []);

  const handlePrintKhInvoice = useCallback(async (invoiceNo) => {
    try {
      if (!invoiceNo) throw new Error("Invoice number is missing");
      const response = await fetch(`${URLs.khInvoiceViewUrl}/${invoiceNo}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (!response.ok) throw new Error("Failed to fetch invoice");
      window.open(URL.createObjectURL(await response.blob()), "_blank");
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  }, []);

  const ActionCellRenderer = (props) => {
    const handleDownload = async () => {
      if (!servicesData.length || !ALL_COLUMN_DEFS.length) return;

      const exportColumns = ALL_COLUMN_DEFS.filter(
        (col) => col.field !== "financialInstitutionName"
      );

      const numericFields = exportColumns
        .map((col) => col.field)
        .filter((field) => servicesData.some((row) => typeof row[field] === "number"));

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("EmployeeData");

      worksheet.columns = exportColumns.map((col) => ({
        header: col.headerName,
        key: col.field,
      }));

      servicesData.forEach((row) => {
        const rowData = {};
        exportColumns.forEach((col) => {
          rowData[col.field] = row[col.field] ?? "";
        });
        worksheet.addRow(rowData);
      });

      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD9D9D9" },
        };
      });

      const totalRowData = {};
      exportColumns.forEach((col, idx) => {
        if (idx === 0) {
          totalRowData[col.field] = "Total";
        } else if (numericFields.includes(col.field)) {
          totalRowData[col.field] = servicesData.reduce(
            (sum, row) => sum + (Number(row[col.field]) || 0),
            0
          );
        } else {
          totalRowData[col.field] = "";
        }
      });
      worksheet.addRow(totalRowData).font = { bold: true };

      worksheet.columns.forEach((column) => {
        let maxLength = column.header ? column.header.length : 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellLength = cell.value != null ? cell.value.toString().length : 0;
          maxLength = Math.max(maxLength, cellLength);
        });
        column.width = maxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        "Monthly_Business_Entries_Data.xlsx"
      );
    };

    const misColumnOptions = ALL_COLUMN_DEFS.filter((col) => col.field).map((col) => ({
      label: col.headerName,
      value: col.field,
      field: col.field,
    }));
    const usedMisFields = misFilters.map((f) => f.column?.field).filter(Boolean);

    const handleMisColumnChange = (index, newColumn) => {
      setMisFilters((prev) => {
        const updated = [...prev];
        updated[index] = { column: newColumn, text: "" };
        return updated;
      });
    };

    const handleMisTextChange = (index, value) => {
      setMisFilters((prev) => {
        const updated = [...prev];
        updated[index] = { ...updated[index], text: value };
        return updated;
      });
    };

    const handleAddMisFilter = () => {
      setMisFilters((prev) => [...prev, { column: null, text: "" }]);
    };

    const handleRemoveMisFilter = (index) => {
      setMisFilters((prev) => {
        if (prev.length === 1) return [{ column: null, text: "" }];
        return prev.filter((_, i) => i !== index);
      });
    };

    const handleClearAllMisFilters = () => {
      setMisFilters([{ column: null, text: "" }]);
    };

    return (
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          p: 1.5,
          backgroundColor: "#fff",
          width: "100%",
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Typography variant="subtitle2" fontWeight={600} color="#333">
            Filters
          </Typography>
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              onClick={handleAddMisFilter}
              disabled={misFilters.length >= misColumnOptions.length}
              sx={{ textTransform: "none", fontSize: 12 }}
            >
              + Add Filter
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="error"
              onClick={handleClearAllMisFilters}
              disabled={misFilters.length === 1 && !misFilters[0].column && !misFilters[0].text}
              sx={{ textTransform: "none", fontSize: 12 }}
            >
              Clear All
            </Button>
            <StyledButton onClick={handleDownload}>
              <DownloadForOfflineIcon fontSize="medium" />
            </StyledButton>
          </Stack>
        </Stack>

        {misFilters.map((filter, index) => (
          <Grid
            container
            spacing={1.5}
            alignItems="center"
            key={index}
            sx={{ mb: index < misFilters.length - 1 ? 1 : 0 }}
          >
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={misColumnOptions.filter(
                  (opt) => !usedMisFields.includes(opt.field) || opt.field === filter.column?.field
                )}
                getOptionLabel={(option) => option.label}
                value={filter.column}
                onChange={(_, newVal) => handleMisColumnChange(index, newVal)}
                isOptionEqualToValue={(opt, val) => opt.value === val.value}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Column ${index + 1}`}
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={filter.column ? `Search in "${filter.column.label}"` : "Search value"}
                variant="outlined"
                size="small"
                value={filter.text}
                onChange={(e) => handleMisTextChange(index, e.target.value)}
                disabled={!filter.column}
                placeholder={
                  filter.column
                    ? `Type to filter ${filter.column.label}...`
                    : "Select a column first"
                }
              />
            </Grid>
            <Grid item xs={12} sm={1} sx={{ display: "flex", justifyContent: "center" }}>
              <IconButton
                size="small"
                onClick={() => handleRemoveMisFilter(index)}
                title="Remove filter"
                sx={{ color: "#d32f2f" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Box>
    );
  };

  const triggerApiCall = () => {
    businessCodeRef.current = monthId;
    fetchEntriesByMonthId();
  };
  const triggerApiDsaBCall = () => {
    businessCodeRef.current = monthId;
    fetchEntriesByDSAMonthId();
    fetchReceivableData();
  };

  function formatDateToDDMonYYYY(dateString) {
    if (!dateString) return "";
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return `${String(date.getDate()).padStart(2, "0")}-${
      months[date.getMonth()]
    }-${date.getFullYear()}`;
  }

  // const ALL_COLUMN_DEFS = [
  //   {
  //     headerName: "Report Month",
  //     field: "reportMonth",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 140,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "Banker Name",
  //     field: "bankerName",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 250,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "Application Number",
  //     field: "applicationNumber",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //   },
  //   {
  //     headerName: "Date",
  //     field: "date",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 130,
  //     flex: 1,
  //     valueFormatter: (params) =>
  //       !params.data?.isFooter ? formatDateToDDMonYYYY(params.value) : "",
  //   },
  //   {
  //     headerName: "Product",
  //     field: "product",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 100,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "Customer Name",
  //     field: "customerName",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //   },
  //   {
  //     headerName: "Applied Amount",
  //     field: "appliedAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Net Disbursement",
  //     field: "netDisbursement",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Actual Disbursement",
  //     field: "actualDisbursement",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Est. Net %",
  //     field: "estNetPercent",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 150,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value !== undefined && params.value !== null ? `${params.value.toFixed(2)}%` : "",
  //   },
  //   {
  //     headerName: "Act. Net %",
  //     field: "actNetPercent",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 150,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value !== undefined && params.value !== null ? `${params.value.toFixed(2)}%` : "",
  //   },
  //   {
  //     headerName: "Estimate Revenue",
  //     field: "estimateRevenue",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Actual Revenue",
  //     field: "actualRevenue",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Disbursement Diff",
  //     field: "diffDisb",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 170,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Revenue Diff",
  //     field: "diffRevenue",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 170,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Net Revenue Impact",
  //     field: "netRevenueImpact",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "DSA Payout (%)",
  //     field: "dsaPayoutPercent",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 160,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value !== undefined && params.value !== null ? `${params.value.toFixed(2)}%` : "",
  //   },
  //   {
  //     headerName: "Est. DSA Payout Amt",
  //     field: "estDSAPayoutAmt",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 190,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Act. DSA Payout Paid",
  //     field: "actDSAPayoutPaid",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 190,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Employee Name",
  //     field: "employeeName",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //   },
  //   {
  //     headerName: "Employee Code",
  //     field: "employeeCode",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 160,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "DSA Name",
  //     field: "dsaName",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //   },
  //   {
  //     headerName: "DSA Code",
  //     field: "dsaCode",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 150,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "Actual Month",
  //     field: "actualMonth",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 140,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "Source 1",
  //     field: "source1",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 130,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "Source 2",
  //     field: "source2",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 130,
  //     flex: 1,
  //   },
  //   {
  //     headerName: "Provider Invoiced Amount",
  //     field: "providerInvoicedAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Provider TDS Amount",
  //     field: "providerAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 160,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Actual Received",
  //     field: "actualReceived",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 160,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Provider Payout Status",
  //     field: "providerPayoutSttaus",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellRenderer: (params) => {
  //       const status = params.value;
  //       const invoiceNo = params.data?.headOfficeInvoiceNo;
  //       const handleClick = () =>
  //         invoiceNo
  //           ? handlePrintKhInvoice(invoiceNo)
  //           : showAlert("Invoice number is missing", "error");
  //       const isReceived = status?.toLowerCase() === "received";
  //       return (
  //         <span
  //           style={{
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "center",
  //             gap: "8px",
  //             height: "100%",
  //           }}
  //         >
  //           <span
  //             style={{
  //               backgroundColor: isReceived ? "#e6f0ff" : "#ffe6e6",
  //               color: isReceived ? "#1a73e8" : "#d93025",
  //               padding: "4px 10px",
  //               height: "30px",
  //               borderRadius: "12px",
  //               fontSize: "12px",
  //               fontWeight: 500,
  //               minWidth: "100px",
  //               textAlign: "center",
  //               display: params.value ? "flex" : "none",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               cursor: "pointer",
  //             }}
  //           >
  //             {params.value}
  //           </span>
  //           <Tooltip title="View Invoice">
  //             <button
  //               onClick={handleClick}
  //               style={{
  //                 display: invoiceNo ? "flex" : "none",
  //                 border: "none",
  //                 background: "transparent",
  //                 cursor: "pointer",
  //                 color: "#007bff",
  //               }}
  //             >
  //               <VisibilityIcon fontSize="medium" />
  //             </button>
  //           </Tooltip>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     headerName: "Received",
  //     field: "providerReceivedAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value != null
  //         ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
  //         : "",
  //   },
  //   {
  //     headerName: "Not Received",
  //     field: "providerNotReceivedAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value != null
  //         ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
  //         : "",
  //   },
  //   {
  //     headerName: "DSA Invoiced Amount",
  //     field: "dsaInvoicedAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 190,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "DSA TDS Amount",
  //     field: "dsaTdsAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 160,
  //     flex: 1,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "Actual Transaction Amount",
  //     field: "actualTransactionAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
  //   },
  //   {
  //     headerName: "DMA Payout Status",
  //     field: "dmaPayoutStatus",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellRenderer: (params) => {
  //       const invoiceNo = params.data?.dsaInvoiceNo;
  //       const status = params.value;
  //       const handleClick = () =>
  //         invoiceNo
  //           ? handlePrintInvoice(invoiceNo)
  //           : showAlert("Invoice number is missing", "error");
  //       const isPaid = status?.toLowerCase() === "paid";
  //       return (
  //         <span
  //           style={{
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "center",
  //             gap: "8px",
  //             height: "100%",
  //           }}
  //         >
  //           <span
  //             style={{
  //               backgroundColor: isPaid ? "#e6f0ff" : "#ffe6e6",
  //               color: isPaid ? "#1a73e8" : "#d93025",
  //               padding: "4px 10px",
  //               height: "30px",
  //               borderRadius: "12px",
  //               fontSize: "12px",
  //               fontWeight: 500,
  //               minWidth: "70px",
  //               textAlign: "center",
  //               display: params.value ? "flex" : "none",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               cursor: "pointer",
  //             }}
  //           >
  //             {params.value}
  //           </span>
  //           <Tooltip title="View Invoice">
  //             <button
  //               onClick={handleClick}
  //               style={{
  //                 display: invoiceNo ? "flex" : "none",
  //                 border: "none",
  //                 background: "transparent",
  //                 cursor: "pointer",
  //                 color: "#007bff",
  //               }}
  //             >
  //               <VisibilityIcon fontSize="medium" />
  //             </button>
  //           </Tooltip>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     headerName: "Connector Payout",
  //     field: "subDSAPaymentAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value != null
  //         ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
  //         : "",
  //   },
  //   {
  //     headerName: "Paid",
  //     field: "paidAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value != null
  //         ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
  //         : "",
  //   },
  //   {
  //     headerName: "Not Paid",
  //     field: "notPaidAmount",
  //     filter: true,
  //     sortable: true,
  //     minWidth: 180,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value != null
  //         ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
  //         : "",
  //   },
  //   {
  //     headerName: "kH Profit",
  //     field: "khProfit",
  //     filter: true,
  //     pinned: "right",
  //     sortable: true,
  //     minWidth: 200,
  //     flex: 1.5,
  //     cellStyle: { textAlign: "right", fontWeight: "500" },
  //     valueFormatter: (params) =>
  //       params.value != null
  //         ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
  //         : "",
  //   },
  // ];
  const ALL_COLUMN_DEFS = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
    },
    {
      headerName: "Application Number",
      field: "applicationNumber",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
    },
    {
      headerName: "Customer Name",
      field: "customerName",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
    },
    {
      headerName: "Entry Date",
      field: "entryDate",
      filter: true,
      sortable: true,
      minWidth: 130,
      flex: 1,
      valueFormatter: (params) =>
        !params.data?.isFooter ? formatDateToDDMonYYYY(params.value) : "",
    },
    {
      headerName: "Business Type",
      field: "businessType",
      filter: true,
      sortable: true,
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "Banker Name",
      field: "bankerName",
      filter: true,
      sortable: true,
      minWidth: 250,
      flex: 1.5,
    },
    {
      headerName: "Financial Institution",
      field: "financialInstitutionName",
      filter: true,
      sortable: true,
      minWidth: 220,
      flex: 1.5,
      hide: true,
    },
    {
      headerName: "Provider Name",
      field: "providerName",
      filter: true,
      sortable: true,
      minWidth: 220,
      flex: 1.5,
    },
    {
      headerName: "Invoice Display Number",
      field: "invoiceDisplayNumber",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellRenderer: (params) => {
        const invoiceDisplayNumber = params.value;
        const invoiceNo = params.data?.invoiceNo;
        const dsaId = params.data?.dsaId;
        const isFooter = params.data?.footerRow || params.data?.isFooter;
        const handleClick = () => {
          if (!invoiceNo) return;
          dsaId === 0 ? handlePrintKhInvoice(invoiceNo) : handlePrintInvoice(invoiceNo);
        };
        return (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>{invoiceDisplayNumber}</span>
            {!isFooter && invoiceNo ? (
              <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
                <VisibilityIcon fontSize="small" />
              </IconButton>
            ) : null}
          </div>
        );
      },
    },
    {
      headerName: "Applied Amount",
      field: "appliedAmount",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Actual Disburse",
      field: "totalDsaBusiness",
      filter: true,
      sortable: true,
      minWidth: 190,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Diff Disbursement",
      field: "diffDisb",
      filter: true,
      sortable: true,
      minWidth: 170,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Est. Gross %",
      field: "estGross",
      filter: true,
      sortable: true,
      minWidth: 140,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        typeof params.value === "number" && !isNaN(params.value)
          ? `${params.value.toFixed(2)}%`
          : "",
    },
    {
      headerName: "Actual Gross %",
      field: "actualGross",
      filter: true,
      sortable: true,
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        typeof params.value === "number" && !isNaN(params.value)
          ? `${params.value.toFixed(2)}%`
          : "",
    },
    {
      headerName: "Grid Diff %",
      field: "gridDiffPer",
      filter: true,
      sortable: true,
      minWidth: 140,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        typeof params.value === "number" && !isNaN(params.value)
          ? `${params.value.toFixed(2)}%`
          : "",
    },
    {
      headerName: "Actual Revenue",
      field: "actualRevenue",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Estimate Revenue",
      field: "estimateRevenue",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    // {
    //   headerName: "Total Gross Payouts",
    //   field: "totalGrossPayouts",
    //   filter: true,
    //   sortable: true,
    //   minWidth: 190,
    //   flex: 1.5,
    //   cellStyle: { textAlign: "right", fontWeight: "500" },
    //   valueFormatter: (params) =>
    //     `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    // },
    {
      headerName: "Grid Diff",
      field: "gridDiff",
      filter: true,
      sortable: true,
      minWidth: 170,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Total Final Gross Payouts",
      field: "totalFinalGrossPayouts",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Total DSA Payout Amount",
      field: "totalDsaPayoutAmount",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Total Final DSA Payouts Amount",
      field: "totalFinalDsaPayoutsAmount",
      filter: true,
      sortable: true,
      minWidth: 220,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Total Sub DSA Payout Amount",
      field: "totalSubDsaPayoutAmount",
      filter: true,
      sortable: true,
      minWidth: 210,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Total Final Sub DSA Payouts Amount",
      field: "totalFinalSubDsaPayoutsAmount",
      filter: true,
      sortable: true,
      minWidth: 230,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Business Status",
      field: "businessStatusDesc",
      filter: true,
      sortable: true,
      minWidth: 160,
      flex: 1.5,
      cellRenderer: (params) => {
        const status = params.value;
        const isFull = status?.toLowerCase() === "fully";
        return (
          <span
            style={{
              backgroundColor: isFull ? "#e6f0ff" : "#fff3e0",
              color: isFull ? "#1a73e8" : "#d46b08",
              padding: "4px 10px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: 500,
              display: params.value ? "inline-flex" : "none",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      headerName: "Invoice Status",
      field: "invoiceStatusDesc",
      filter: true,
      sortable: true,
      minWidth: 260,
      flex: 2,
      cellRenderer: (params) => {
        const status = params.value;
        const isReceived = status?.toLowerCase().includes("amount received");
        return (
          <span
            style={{
              color: isReceived ? "#2e7d32" : "inherit",
              fontWeight: isReceived ? 600 : 400,
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      headerName: "DSA Revenue",
      field: "dsaRevenue",
      filter: true,
      pinned: "right",
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
  ];
  const childGridColDefs = [
    {
      headerName: "Banker Name",
      field: "bankerName",
      filter: true,
      sortable: true,
      minWidth: 250,
      flex: 1,
    },
    {
      headerName: "Application Number",
      field: "applicationNumber",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
    },
    {
      headerName: "headOfiiceInvoiceSerialNumber",
      field: "headOfiiceInvoiceSerialNumber",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
    },
    {
      headerName: "Customer Name",
      field: "customerName",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
    },
    { headerName: "Date", field: "date", filter: true, sortable: true, minWidth: 130, flex: 1 },
    {
      headerName: "Disbursement",
      field: "actualDisbursement",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Gross Payout",
      field: "actualRevenue",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellRenderer: (params) => {
        const amount = params.value;
        const status = params.data?.providerPayoutSttaus;
        const invoiceNo = params.data?.headOfficeInvoiceNo;
        const handleClick = () =>
          invoiceNo
            ? handlePrintKhInvoice(invoiceNo)
            : showAlert("Invoice number is missing", "error");
        let textColor =
          status?.toLowerCase() === "received" && invoiceNo
            ? "#27ae60"
            : status?.toLowerCase() === "not received" && invoiceNo
            ? "#d4ac0d"
            : "#1c2833";
        return (
          <Tooltip title={invoiceNo ? "View Invoice" : ""} disableInteractive={!invoiceNo}>
            <span
              style={{
                color: textColor,
                cursor: invoiceNo ? "pointer" : "default",
                border: invoiceNo ? `1px solid ${textColor}` : "none",
                borderRadius: "7px",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "100%",
                padding: "0 8px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              onClick={invoiceNo ? handleClick : null}
            >{`₹ ${amount?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`}</span>
          </Tooltip>
        );
      },
    },
    {
      headerName: "DSA Payout",
      field: "actDSAPayoutPaid",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellRenderer: (params) => {
        const amount = params.value;
        const status = params.data?.dmaPayoutStatus;
        const invoiceNo = params.data?.dsaInvoiceNo;
        const handleClick = () =>
          invoiceNo
            ? handlePrintInvoice(invoiceNo)
            : showAlert("Invoice number is missing", "error");
        let textColor =
          status?.toLowerCase() === "paid" && invoiceNo
            ? "#27ae60"
            : status?.toLowerCase() === "not paid" && invoiceNo
            ? "#d4ac0d"
            : "#1c2833";
        return (
          <Tooltip title={invoiceNo ? "View Invoice" : ""} disableInteractive={!invoiceNo}>
            <span
              style={{
                color: textColor,
                cursor: invoiceNo ? "pointer" : "default",
                border: invoiceNo ? `1px solid ${textColor}` : "none",
                borderRadius: "7px",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "100%",
                padding: "0 8px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              onClick={invoiceNo ? handleClick : null}
            >{`₹ ${amount?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`}</span>
          </Tooltip>
        );
      },
    },
    {
      headerName: "Connector Payout",
      field: "subDSAPaymentAmount",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
    {
      headerName: "Est kH Profit",
      field: "khProfit",
      pinned: "right",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 130,
      maxWidth: 130,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.data &&
        params.data.actualRevenue != null &&
        params.data.subDSAPaymentAmount != null &&
        params.data.actDSAPayoutPaid != null
          ? `₹ ${(
              params.data.actualRevenue -
              params.data.subDSAPaymentAmount -
              params.data.actDSAPayoutPaid
            ).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
  ];

  const makeFooterRow = (total) => ({
    remarks: "Total",
    ...total,
    balance: total.notPaidAmount - total.paidAmount,
    balanceT: total.providerNotReceivedAmount - total.providerReceivedAmount,
    khProfit: total.providerReceivedAmount - total.paidAmount,
    footerRow: true,
    estNetPercent: null,
    actNetPercent: null,
    dsaPayoutPercent: null,
    dsaInvoiceNo: null,
    headOfficeInvoiceNo: null,
    dsaInvoiceSerialNumber: null,
    headOfficeInvoiceSerialNumber: null,
    providerPayoutStatus: null,
    dmaPayoutStatus: null,
    reportMonth: null,
    bankerName: null,
    applicationNumber: null,
    date: null,
    product: null,
    customerName: null,
    employeeName: null,
    employeeCode: null,
    dsaName: null,
    dsaCode: null,
    actualMonth: null,
    source1: null,
    source2: null,
  });
  const emptyTotal = {
    appliedAmount: 0,
    netDisbursement: 0,
    actualDisbursement: 0,
    estimateRevenue: 0,
    actualRevenue: 0,
    diffDisb: 0,
    diffRevenue: 0,
    subDSAPaymentAmount: 0,
    netRevenueImpact: 0,
    estDSAPayoutAmt: 0,
    actDSAPayoutPaid: 0,
    dsaInvoiceNo: 0,
    headOfficeInvoiceNo: 0,
    dsaInvoicedAmount: 0,
    dsaTdsAmount: 0,
    providerInvoicedAmount: 0,
    providerAmount: 0,
    actualReceived: 0,
    actualTransactionAmount: 0,
    paidAmount: 0,
    notPaidAmount: 0,
    providerReceivedAmount: 0,
    providerNotReceivedAmount: 0,
  };

  useEffect(() => {
    const total = childGridData.reduce(
      (acc, row) => {
        Object.keys(emptyTotal).forEach((k) => {
          if (typeof row[k] === "number" && !isNaN(row[k])) acc[k] += row[k];
        });
        return acc;
      },
      { ...emptyTotal }
    );
    setFooterChildGridData([makeFooterRow(total)]);
  }, [childGridData]);

  const MIS_AMOUNT_FIELDS = [
    "totalDsaBusiness",
    "totalGrossPayouts",
    "totalFinalGrossPayouts",
    "totalDsaPayoutAmount",
    "totalFinalDsaPayoutsAmount",
    "totalSubDsaPayoutAmount",
    "totalFinalSubDsaPayoutsAmount",
    "dsaRevenue",
    "appliedAmount",
    "actualRevenue",
    "diffDisb",
    "estimateRevenue",
    "gridDiff",
  ];

  // Percentage fields are averaged (not summed) in the footer row
  const MIS_PERCENT_FIELDS = ["estGross", "actualGross", "gridDiffPer"];

  useEffect(() => {
    setRowData(filteredData);
    const emptyMisTotal = MIS_AMOUNT_FIELDS.reduce((acc, k) => ({ ...acc, [k]: 0 }), {});
    const total = filteredData.reduce((acc, row) => {
      MIS_AMOUNT_FIELDS.forEach((k) => {
        if (typeof row[k] === "number" && !isNaN(row[k])) acc[k] += row[k];
      });
      return acc;
    }, emptyMisTotal);

    const percentTotals = {};
    MIS_PERCENT_FIELDS.forEach((k) => {
      const values = filteredData
        .map((row) => row[k])
        .filter((v) => typeof v === "number" && !isNaN(v));
      percentTotals[k] = values.length
        ? values.reduce((sum, v) => sum + v, 0) / values.length
        : null;
    });

    setFooterData([{ dsaName: "Total", footerRow: true, ...total, ...percentTotals }]);
  }, [filteredData, servicesData]);

  useEffect(() => {
    const total = dsaBusiness.reduce(
      (acc, row) => {
        acc.business += row.business || 0;
        acc.grossPayout += row.grossPayout || 0;
        acc.dsaPayout += row.dsaPayout || 0;
        acc.expenditure += row.expenditure || 0;
        acc.netIncome += row.netIncome || 0;
        acc.subDsaPayments += row.subDsaPayments || 0;
        return acc;
      },
      { business: 0, subDsaPayments: 0, grossPayout: 0, dsaPayout: 0, expenditure: 0, netIncome: 0 }
    );
    setDsaFooterData([{ dsaName: "Total", dsaId: "", ...total, footerRow: true }]);
  }, [dsaBusiness]);

  const dsaBusinessColDefs = [
    { headerName: "DSA Name", field: "dsaName", pinned: "left", flex: 1 },
    {
      headerName: "Business",
      field: "business",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Gross Payout",
      field: "grossPayout",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "DSA Payout",
      field: "dsaPayout",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Connector Payout",
      field: "subDsaPayments",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Actions",
      field: "actions",
      flex: 0.5,
      cellRenderer: (params) => {
        if (params.data?.footerRow) return null;
        return (
          <Tooltip title="View" arrow>
            <IconButton type="button" onClick={() => handleViewClick(params)} color="primary">
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const fetchChildGridData = useCallback(
    async (dsaId) => {
      if (startDate && endDate) {
        const s = dayjs(startDate).format("YYYY-MM-DD");
        const e = dayjs(endDate).format("YYYY-MM-DD");
        setLoading(true);
        try {
          const responseA = await fetch(
            `${URLs.pAndLByDsaId}?startDate=${s}&endDate=${e}&dsaId=${dsaId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`,
              },
            }
          );
          const dataA = await responseA.json();
          if (responseA.ok) {
            setChildGridData([...dataA]);
          } else {
            throw new Error("Failed to fetch entries data");
          }
        } catch (error) {
          showAlert(`Failed to fetch data: ${error.message}`, "error");
        } finally {
          setLoading(false);
        }
      } else {
        showAlert("Please select both start and end dates", "error");
      }
    },
    [selectedDSA]
  );

  const fetchReceivableData = useCallback(async () => {
    if (startDate && endDate) {
      const s = dayjs(startDate).format("YYYY-MM-DD");
      const e = dayjs(endDate).format("YYYY-MM-DD");
      setLoading(true);
      try {
        const options = {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        };
        // Old APIs - replaced by single combined endpoint below
        // const [resA, resB] = await Promise.all([
        //   fetch(`${URLs.dsaReceivablesKh}?startDate=${s}&endDate=${e}`, options),
        //   fetch(`${URLs.dsaReceivables}?startDate=${s}&endDate=${e}`, options),
        // ]);
        // const [dataA, dataB] = await Promise.all([resA.json(), resB.json()]);
        // if (resA.ok) {
        //   setDsaReceivables([...dataA, ...dataB]);
        // } else {
        //   throw new Error("Failed to fetch entries data");
        // }

        const response = await fetch(
          `${URLs.confirmedAcctWiseAllDsaBusiness}?startDate=${s}&endDate=${e}`,
          options
        );
        if (!response.ok) throw new Error("Failed to fetch entries data");
        const data = await response.json();
        setDsaReceivables(data);
      } catch (error) {
        showAlert(`Failed to fetch data: ${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    } else {
      showAlert("Please select both start and end dates", "error");
    }
  });
  const handleViewClick = (params) => {
    setPopoverOpen(true);
    setSelectedDSA(params.data.dsaId);
    fetchChildGridData(params.data.dsaId);
  };

  const closePopover = () => {
    setPopoverOpen(false);
    setSelectedDSA(null);
    setChildGridData([]);
  };

  const receivableColdefs = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      minWidth: 200,
      pinned: "left",
      cellClass: "fw-600",
    },
    {
      headerName: "Total Business",
      field: "totalBusiness",
      minWidth: 170,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    // {
    //   headerName: "Revenue",
    //   field: "revenue",
    //   minWidth: 150,
    //   flex: 1,
    //   cellStyle: { textAlign: "right", fontWeight: "500" },
    //   valueFormatter: (params) =>
    //     `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    // },
    // {
    //   headerName: "Additional Amount",
    //   field: "totalAdditionalAmount",
    //   minWidth: 170,
    //   flex: 1,
    //   cellStyle: { textAlign: "right", fontWeight: "500" },
    //   valueFormatter: (params) =>
    //     `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    // },
    // {
    //   headerName: "Recoveries",
    //   field: "totalRecoveries",
    //   minWidth: 150,
    //   flex: 1,
    //   cellStyle: { textAlign: "right", fontWeight: "500" },
    //   valueFormatter: (params) =>
    //     `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    // },
    {
      headerName: "Net Revenue",
      field: "netRevenue",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Invoiced Amount",
      field: "invoiceAmount",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Total GST",
      field: "totalGst",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    // {
    //   headerName: "Received Amount",
    //   field: "receivedAmount",
    //   minWidth: 160,
    //   flex: 1,
    //   cellStyle: { textAlign: "right", fontWeight: "500" },
    //   valueFormatter: (params) =>
    //     `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    // },
    {
      headerName: "Balance",
      field: "balance",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      minWidth: 160,
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    //i want to add extram column which named as "netReceivedAmount": 9198329.48
    {
      headerName: "Net Received Amount",
      field: "netReceivedAmount",
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    //i want to add extra header with name netReceiptAmount
    {
      headerName: "Net Receipt Amount",
      field: "netReceiptAmount",
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
  ];
  useEffect(() => {
    if (activeTab === 1) {
      fetchEntriesByDSAMonthId();
      fetchReceivableData();
      fetchReceivablesWithoutDateRangeData();
      fetcNotInvoicedData();
    }
  }, [activeTab]);

  useEffect(() => {
    const total = dsaReceivables.reduce(
      (acc, row) => {
        acc.totalBusiness += row.totalBusiness || 0;
        acc.revenue += row.revenue || 0;
        acc.totalAdditionalAmount += row.totalAdditionalAmount || 0;
        acc.totalRecoveries += row.totalRecoveries || 0;
        acc.netRevenue += row.netRevenue || 0;
        acc.invoiceAmount += row.invoiceAmount || 0;
        acc.totalGst += row.totalGst || 0;
        acc.receivedAmount += row.receivedAmount || 0;
        acc.balance += row.balance || 0;
        acc.netReceivedAmount += row.netReceivedAmount || 0;
        acc.netReceiptAmount += row.netReceiptAmount || 0;
        return acc;
      },
      {
        totalBusiness: 0,
        revenue: 0,
        totalAdditionalAmount: 0,
        totalRecoveries: 0,
        netRevenue: 0,
        invoiceAmount: 0,
        totalGst: 0,
        receivedAmount: 0,
        balance: 0,
        netReceivedAmount: 0,
        netReceiptAmount: 0,
      }
    );
    setReceivableFooterData([{ dsaName: "Total", dsaId: "", ...total, footerRow: true }]);
  }, [dsaReceivables]);

  const ViewBalanceCellRenderer = (props) => {
    const isFooter = props.data?.footerRow;
    const handleClick = async () => {
      const dsaId = props.data?.dsaId;
      setHighlightAllRowsInv(dsaId);
      setLoading(true);
      if (dsaId == undefined || null) return;
      const url = dsaId
        ? `${URLs.receivableAgainstDsa}?dsaId=${dsaId}`
        : `${URLs.receivableAgainstDsaKh}?dsaId=${dsaId}`;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        });
        if (!response.ok) throw new Error("Failed to fetch DSA details");
        setRecievablesAgtInvData(await response.json());
      } catch (error) {
        console.error("API call error:", error.message);
      }
      setLoading(false);
    };
    return (
      <div className="flex justify-between items-center pr-2">
        <span>{props.valueFormatted}</span>
        {isFooter ? null : (
          <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        )}
      </div>
    );
  };
  ViewBalanceCellRenderer.propTypes = { data: PropTypes.object, valueFormatted: PropTypes.any };

  const ViewInvCellRenderer = (props) => {
    const isFooter = props.data?.footerRow;
    const handleClick = async () => {
      const invNo = props.data?.invoiceNo;
      const dsaId = props.data?.dsaId;
      if (invNo === undefined || invNo === null) return;
      dsaId === 0 ? handlePrintKhInvoice(invNo) : handlePrintInvoice(invNo);
    };
    return (
      <div className="flex justify-between items-center pr-2">
        <span>{props.value}</span>
        {isFooter ? null : (
          <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        )}
      </div>
    );
  };
  ViewInvCellRenderer.propTypes = { data: PropTypes.object, value: PropTypes.any };
  //i want  for below function fetching dsa name,balance from the Confirmed Business A/C MIS ledger

  const recievablesAgainstInvoice = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      minWidth: 200,
      pinned: "left",
      cellClass: "fw-600",
    },
    {
      headerName: "Balance",
      field: "balance",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellRenderer: ViewBalanceCellRenderer,
    },
  ];

  const recievablesAgtInvColDefs = [
    {
      headerName: "Invoice Display No",
      field: "invoiceDisplayNumber",
      minWidth: 200,
      cellClass: (params) => (params.data?.footerRow ? "fw-600" : ""),
      cellRenderer: ViewInvCellRenderer,
    },
    {
      headerName: "Date",
      field: "date",
      minWidth: 160,
      valueFormatter: (params) => {
        if (!params.value) return "";
        return new Date(params.value).toLocaleDateString("en-IN", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      },
      cellClass: (params) => (params.data?.footerRow ? "fw-600" : ""),
    },
    {
      headerName: "Provider Name",
      field: "providerName",
      minWidth: 200,
      cellClass: (params) => (params.data?.footerRow ? "fw-600" : ""),
    },
    {
      headerName: "Total",
      field: "total",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        typeof params.value === "number"
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
      cellClass: (params) => `text-end ${params.data?.footerRow ? "fw-600" : ""}`,
    },
    {
      headerName: "Balance",
      field: "balance",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        typeof params.value === "number"
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
      cellClass: (params) => `text-end ${params.data?.footerRow ? "fw-600" : ""}`,
    },
  ];

  const fetchReceivablesWithoutDateRangeData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${URLs.recivablesWithoutDateRange}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
      });
      if (!res.ok) {
        return;
      } //throw new Error("Failed to fetch entries data");
      const data = await res.json();
      setRecievablesAgainstInvoiceData(data);
    } catch (error) {
      showAlert(`Failed to fetch data: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const total = recievablesAgainstInvoiceData.reduce(
      (acc, row) => {
        acc.invoiceTotal += row.invoiceTotal || 0;
        acc.totalGST += row.totalGST || 0;
        acc.invoicedAmount += row.invoicedAmount || 0;
        acc.receivedAmount += row.receivedAmount || 0;
        acc.balanceAmount += row.balanceAmount || 0;
        acc.txnCount += row.txnCount || 0;
        return acc;
      },
      {
        invoiceTotal: 0,
        totalGST: 0,
        invoicedAmount: 0,
        receivedAmount: 0,
        balanceAmount: 0,
        txnCount: 0,
      }
    );
    setRecievablesAgainstInvoiceFooterData([
      { dsaName: "Total", dsaId: "", ...total, footerRow: true },
    ]);
  }, [recievablesAgainstInvoiceData]);

  useEffect(() => {
    const total = recievablesAgtInvData.reduce(
      (acc, row) => {
        acc.total += row.total || 0;
        acc.balance += row.balance || 0;
        return acc;
      },
      { total: 0, balance: 0 }
    );
    setRecievablesAgtInvfooterData([
      {
        invoiceNo: "",
        invoiceDisplayNumber: "",
        date: "",
        providerName: "Total",
        ...total,
        footerRow: true,
      },
    ]);
  }, [recievablesAgtInvData]);

  const ViewNotInvCellRenderer = (props) => {
    const isFooter = props.data?.footerRow;
    const handleClick = async () => {
      const dsaId = props.data?.dsaId;
      const dsaName = props.data?.dsaName;
      setCompanyId(dsaId);
      setSelectedRange(30);
      setSelectedDSAName(dsaName);
      setLoading(true);
      const today = new Date();
      const past30 = new Date();
      past30.setDate(today.getDate() - 30);
      const url = `${URLs.allPayoutsNotReceivableNotRaisedInvoice}/DateRange/${dsaId}?startDate=${
        past30.toISOString().split("T")[0]
      }&endDate=${today.toISOString().split("T")[0]}`;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        });
        if (!response.ok) throw new Error("Failed to fetch DSA details");
        setRecievablesNotInvData(await response.json());
      } catch (error) {
        console.error("API call error:", error.message);
      }
      setLoading(false);
    };
    return (
      <div className="flex justify-between items-center pr-2">
        <span>{props.valueFormatted}</span>
        {!isFooter && (
          <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        )}
      </div>
    );
  };
  ViewNotInvCellRenderer.propTypes = { data: PropTypes.object, valueFormatted: PropTypes.any };

  const notRecievablesNaInvoice = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      minWidth: 200,
      pinned: "left",
      cellClass: "fw-600",
    },
    {
      headerName: "Balance",
      field: "grossPayoutAmount",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellRenderer: ViewNotInvCellRenderer,
    },
  ];

  const recievablesNotInvColDefs = [
    {
      headerName: "Application Number",
      field: "applicationNumber",
      minWidth: 180,
      cellClass: "fw-600",
    },
    {
      headerName: "Date",
      field: "date",
      maxWidth: 120,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleDateString("en-IN", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      },
    },
    { headerName: "DSA Name", field: "dsaName", minWidth: 200 },
    { headerName: "Customer Name", field: "customerName", minWidth: 200 },
    { headerName: "Banker Name", field: "financialInstitutionName", minWidth: 220 },
    {
      headerName: "Disbursed Amount",
      field: "disbursedAmount",
      minWidth: 180,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Gross Payout Amount",
      field: "grossPayoutAmount",
      minWidth: 180,
      pinned: "right",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
  ];

  const fetcNotInvoicedData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${URLs.receivableNotRaisedInvoices}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
      });
      if (!response.ok) throw new Error("Failed to fetch entries data");
      setNotRecievablesNanvoiceData(await response.json());
    } catch (error) {
      showAlert(`Failed to fetch data: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const total = notRecievablesNanvoiceData.reduce(
      (acc, row) => {
        acc.grossPayoutAmount += row.grossPayoutAmount || 0;
        return acc;
      },
      { grossPayoutAmount: 0 }
    );
    setNotRecievablesAgainstInvoiceFooterData([
      { dsaName: "Total", dsaId: "", ...total, footerRow: true },
    ]);
  }, [notRecievablesNanvoiceData]);

  useEffect(() => {
    const totals = recievablesNotInvData.reduce(
      (acc, row) => {
        acc.grossPayoutAmount += row.grossPayoutAmount || 0;
        acc.disbursedAmount += row.disbursedAmount || 0;
        return acc;
      },
      { grossPayoutAmount: 0, disbursedAmount: 0 }
    );
    setRecievablesNotInvfooterData([
      {
        applicationNumber: "",
        date: "TOTAL",
        customerName: "",
        financialInstitutionName: "",
        grossPayoutAmount: totals.grossPayoutAmount,
        disbursedAmount: totals.disbursedAmount,
        dsaName: "Total",
        footerRow: true,
      },
    ]);
  }, [recievablesNotInvData]);

  const handleFilter = async ({ startDate, endDate, isAbove, all, allByCom }) => {
    setLoading(true);
    if (companyId === null || companyId === undefined) {
      showAlert("Please select a DSA first", "error");
      setLoading(false);
      return;
    }
    let url = `${URLs.allPayoutsNotReceivableNotRaisedInvoice}`;
    if (isAbove) {
      url += `/${companyId}/startDate?startDate=${endDate}`;
    } else if (allByCom) {
      url += `/${companyId}`;
    } else if (all) {
      url += `s`;
    } else {
      url += `/DateRange/${companyId}?startDate=${startDate}&endDate=${endDate}`;
    }
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
      });
      if (!response.ok) throw new Error("API call failed");
      setRecievablesNotInvData(await response.json());
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const handleDownloadExcel = () => {
    if (!recievablesNotInvData || recievablesNotInvData.length === 0) {
      showAlert("No data available to export", "warning");
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(recievablesNotInvData);
    worksheet["!cols"] = Object.keys(recievablesNotInvData[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...recievablesNotInvData.map((row) => (row[key] ? row[key].toString().length : 0))
      ),
    }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Receivables_Not_Invoiced");
    saveAs(
      new Blob([XLSX.write(workbook, { bookType: "xlsx", type: "array" })], {
        type: "application/octet-stream",
      }),
      `Account_Receivables_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
    );
  };

  const defaultColDef = { filter: true, sortable: true, resizable: true, floatingFilter: true };

  return (
    <>
      <Dialog open={loading} onClose={() => setLoading(false)}>
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>

      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleCloseAlert} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>

      <Box
        sx={{
          "& .MuiTab-root": {
            whiteSpace: "nowrap",
            minWidth: "fit-content",
            px: 2,
            fontSize: "0.78rem",
          },
          "& .MuiTabs-scroller": { overflowX: "auto !important" },
        }}
      >
        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={handleChange}
          labelColor="#ffffff"
          bgColor="#e0f7fa"
        />
      </Box>

      <Modal open={popoverOpen} onClose={closePopover}>
        <Box
          sx={{
            position: "absolute",
            top: "10vh",
            left: "5vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "90vw",
            height: "90vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          <StyledButton onClick={closePopover} sx={{ mb: 1 }}>
            <CloseIcon fontSize="medium" />
          </StyledButton>
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ height: "50v", width: "100%" }}
          >
            <AgGridReact
              enableCellTextSelection
              enableRangeSelection
              columnDefs={childGridColDefs}
              rowData={childGridData}
              suppressClipboardPaste={false}
              pagination
              defaultColDef={defaultColDef}
              getRowStyle={(params) =>
                params.data?.disbursementStatus === "D"
                  ? { backgroundColor: "#b71c1c", color: "#fff" }
                  : { backgroundColor: "#FFFFFF", color: "#1C2526" }
              }
              paginationPageSize={100}
              animateRows
              pinnedBottomRowData={footerChildGridData}
            />
          </StyledAgGridContainer>
        </Box>
      </Modal>

      <TotalExpenditureStatement
        dsaId={dsaId}
        expenseIsOpen={expenseIsOpen}
        expenseOnClose={handleCloseModal}
        startDate={startDate}
        endDate={endDate}
      />

      <GstDialogPopup
        open={gstLiabilityOpen}
        onClose={() => setGstLiabilityOpen(false)}
        loading={gstLiabilityLoading}
        data={gstLiabilityData}
        mode="gstLiability"
      />
      <GstDialogPopup
        open={igstLiabilityOpen}
        onClose={() => setIgstLiabilityOpen(false)}
        loading={igstLiabilityLoading}
        data={igstLiabilityData}
        mode="igstLiability"
      />
      <GstDialogPopup
        open={gstPaidOpen}
        onClose={() => setGstPaidOpen(false)}
        loading={gstPaidLoading}
        data={gstPaidData}
        mode="gstPaid"
      />
      <GstDialogPopup
        open={igstPaidOpen}
        onClose={() => setIgstPaidOpen(false)}
        loading={igstPaidLoading}
        data={igstPaidData}
        mode="igstPaid"
      />
      <GstDialogPopup
        open={gstReceivableOpen}
        onClose={() => setGstReceivableOpen(false)}
        loading={gstReceivableLoading}
        data={gstReceivableData}
        mode="gstReceivable"
      />

      {activeTab === 0 && (
        <TableContainer
          component={Paper}
          sx={{
            ...monthEndStyles.tableContainer,
            flex: 1,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 1rem)",
          }}
        >
          <Box sx={monthEndStyles.formContainer}>
            <Box sx={monthEndStyles.formItem}>
              <TextField
                label="Start Date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
              <TextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
              <StyledButton onClick={triggerApiCall}>Get</StyledButton>
            </Box>
            {ActionCellRenderer()}
          </Box>
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ height: "80vh", width: "100%", marginBottom: "20px" }}
          >
            <AgGridReact
              enableCellTextSelection
              enableRangeSelection
              columnDefs={ALL_COLUMN_DEFS}
              rowData={filteredData}
              suppressClipboardPaste={false}
              pagination
              defaultColDef={defaultColDef}
              getRowStyle={(params) =>
                params.data?.disbursementStatus === "D"
                  ? { backgroundColor: "#b71c1c", color: "#fff" }
                  : { backgroundColor: "#FFFFFF", color: "#1C2526" }
              }
              paginationPageSize={100}
              pinnedBottomRowData={footerData}
              animateRows
            />
          </StyledAgGridContainer>
        </TableContainer>
      )}

      {activeTab === 1 && (
        <Box
          component={Paper}
          sx={{ mt: 2, p: 2, mb: 1, flex: 1, display: "flex", flexDirection: "column" }}
        >
          <Box sx={monthEndStyles.formContainer}>
            <Box sx={monthEndStyles.formItem}>
              <TextField
                label="Start Date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
              <TextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
              <StyledButton onClick={triggerApiDsaBCall}>Get</StyledButton>
            </Box>
          </Box>
          <ModernHeader label="Total KH business via DSAs & in-house" />
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ minHeight: "500px", width: "100%", marginBottom: "20px" }}
          >
            <AgGridReact
              enableCellTextSelection
              enableRangeSelection
              columnDefs={dsaBusinessColDefs}
              rowData={dsaBusiness}
              suppressClipboardPaste={false}
              pagination
              defaultColDef={defaultColDef}
              paginationPageSize={100}
              pinnedBottomRowData={dsaFooterData}
              animateRows
            />
          </StyledAgGridContainer>
          <ModernHeader label="Confirmed Business A/C MIS" />
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ minHeight: "500px", width: "100%", marginBottom: "20px" }}
          >
            <AgGridReact
              enableCellTextSelection
              enableRangeSelection
              columnDefs={receivableColdefs}
              rowData={dsaReceivables}
              suppressClipboardPaste={false}
              pagination
              defaultColDef={defaultColDef}
              paginationPageSize={100}
              pinnedBottomRowData={receivableFooterData}
              animateRows
            />
          </StyledAgGridContainer>
          <ModernHeader label="Account Receivables Against Invoice" />
          <Grid container spacing={2} sx={{ marginBottom: 2 }}>
            <Grid item xs={12} md={4}>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ height: "500px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection
                  enableRangeSelection
                  columnDefs={recievablesAgainstInvoice}
                  //rowData={recievablesAgainstInvoiceData}
                  rowData={dsaReceivables}
                  suppressClipboardPaste={false}
                  pagination
                  defaultColDef={defaultColDef}
                  paginationPageSize={100}
                  //pinnedBottomRowData={recievablesAgainstInvoiceFooterData}
                  pinnedBottomRowData={receivableFooterData}
                  animateRows
                  getRowStyle={(params) => {
                    if (params.data?.footerRow) return null;
                    if (params.data?.dsaId === highlightAllRowsInv)
                      return { backgroundColor: "#D46B08", color: "#fff" };
                    return null;
                  }}
                />
              </StyledAgGridContainer>
            </Grid>
            <Grid item xs={12} md={8}>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ height: "500px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection
                  enableRangeSelection
                  columnDefs={recievablesAgtInvColDefs}
                  rowData={recievablesAgtInvData}
                  suppressClipboardPaste={false}
                  pagination
                  defaultColDef={defaultColDef}
                  paginationPageSize={100}
                  pinnedBottomRowData={recievablesAgtInvfooterData}
                  animateRows
                />
              </StyledAgGridContainer>
            </Grid>
          </Grid>
          <ModernHeader label="Account Receivables but not raised Invoice" />
          <Grid container spacing={2} sx={{ marginBottom: 2 }}>
            <Grid item xs={12} md={4}>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ minHeight: "400px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection
                  enableRangeSelection
                  columnDefs={notRecievablesNaInvoice}
                  rowData={notRecievablesNanvoiceData}
                  suppressClipboardPaste={false}
                  pagination
                  defaultColDef={defaultColDef}
                  paginationPageSize={100}
                  pinnedBottomRowData={notRecievablesAgainstInvoiceFooterData}
                  animateRows
                  getRowStyle={(params) => {
                    if (highlightAllRows) return { backgroundColor: "#FFF3E0" };
                    if (params.data?.dsaId === companyId)
                      return { backgroundColor: "#D46B08", color: "#fff" };
                    return null;
                  }}
                />
              </StyledAgGridContainer>
            </Grid>
            <Grid item xs={12} md={8}>
              <DaysFilterButtons onFilter={handleFilter} onDownload={handleDownloadExcel} />
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ height: "500px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection
                  enableRangeSelection
                  columnDefs={recievablesNotInvColDefs}
                  rowData={recievablesNotInvData}
                  suppressClipboardPaste={false}
                  defaultColDef={defaultColDef}
                  getRowStyle={(params) =>
                    params.data?.disbursementStatus === "D"
                      ? { backgroundColor: "#b71c1c", color: "#fff" }
                      : { backgroundColor: "#FFFFFF", color: "#1C2526" }
                  }
                  pagination
                  paginationPageSize={100}
                  pinnedBottomRowData={recievablesNotInvfooterData}
                  animateRows
                />
              </StyledAgGridContainer>
            </Grid>
          </Grid>
          <GstTdsGrid setAlert={showAlert} setLoading={setLoading} loading={loading} />
        </Box>
      )}

      {activeTab === 2 && (
        // ── Pass handleNavigateToTab so FinancialSummary can forward it to BalanceSheet ──
        <FinancialSummary isKh={false} onNavigateToTab={handleNavigateToTab} />
      )}

      {activeTab === 3 && (
        // ── Pass handleNavigateToTab so FinancialSummary can forward it to BalanceSheet ──
        <FinancialSummary isKh={true} onNavigateToTab={handleNavigateToTab} />
      )}

      {activeTab === 4 && (
        <Box component={Paper} sx={{ mt: 2, p: 3 }}>
          <Box sx={{ display: "flex", gap: 2, mb: 3, alignItems: "center", flexWrap: "wrap" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1,
                border: "1px solid #FFA726",
                borderRadius: 2,
                backgroundColor: "#FFFDE7",
              }}
            >
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#D46B08",
                  whiteSpace: "nowrap",
                  mr: 0.5,
                }}
              >
                Date Range
              </Typography>
              <TextField
                label="From Date"
                type="date"
                value={gstStartDate}
                onChange={(e) => setGstStartDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "150px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
              <TextField
                label="To Date"
                type="date"
                value={gstEndDate}
                onChange={(e) => setGstEndDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "150px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1,
                border: "1px solid #FFA726",
                borderRadius: 2,
                backgroundColor: "#FFFDE7",
              }}
            >
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#D46B08",
                  whiteSpace: "nowrap",
                  mr: 0.5,
                }}
              >
                Pay Date
              </Typography>
              <TextField
                label="Pay From"
                type="date"
                value={payStartDate}
                onChange={(e) => setPayStartDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "150px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
              <TextField
                label="Pay To"
                type="date"
                value={payEndDate}
                onChange={(e) => setPayEndDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "150px" }}
                InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
              />
            </Box>

            <StyledButton onClick={fetchGstSummary}>Get</StyledButton>
          </Box>

          {gstData.length > 0 && (
            <Box sx={{ mt: 4 }}>
              <ModernHeader label="GST Report Summary" />
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ height: "420px", width: "100%", mt: 1 }}
              >
                <AgGridReact
                  columnDefs={[
                    {
                      headerName: "Sl. No",
                      field: "slNo",
                      maxWidth: 90,
                      cellStyle: { textAlign: "center", fontWeight: "600" },
                    },
                    {
                      headerName: "Particulars",
                      field: "particulars",
                      flex: 2,
                      minWidth: 280,
                      cellRenderer: (params) => {
                        const text = params.value?.toLowerCase() || "";
                        const isClickable =
                          text.includes("total igst liability") ||
                          text.includes("igst liability") ||
                          text.includes("total igst paid") ||
                          text.includes("igst paid") ||
                          text.includes("total gst liability") ||
                          text.includes("gst liability") ||
                          text.includes("total gst paid") ||
                          text.includes("gst paid") ||
                          text.includes("gst receivable") ||
                          text.includes("total gst recei");
                        return (
                          <span
                            style={{
                              cursor: isClickable ? "pointer" : "default",
                              color: isClickable ? "#1a73e8" : "inherit",
                              textDecoration: isClickable ? "underline" : "none",
                              fontWeight: isClickable ? "700" : "inherit",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              if (isClickable) handleParticularClick(params.value);
                            }}
                          >
                            {params.value}
                          </span>
                        );
                      },
                    },
                    {
                      headerName: "Amount (₹)",
                      field: "amount",
                      flex: 1,
                      minWidth: 180,
                      cellStyle: (params) => ({
                        textAlign: "right",
                        fontWeight: "700",
                        color: params.value < 0 ? "#c62828" : "#2e7d32",
                      }),
                      valueFormatter: (params) =>
                        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
                    },
                  ]}
                  rowData={gstData}
                  defaultColDef={{ resizable: true, sortable: true }}
                  getRowStyle={(params) =>
                    params.data?.particulars?.startsWith("CURRENT BALANCE")
                      ? {
                          backgroundColor: params.data.amount < 0 ? "#ffcdd2" : "#c8e6c9",
                          fontWeight: "bold",
                        }
                      : { backgroundColor: "#fff" }
                  }
                  domLayout="autoHeight"
                  animateRows
                />
              </StyledAgGridContainer>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
